import { QuesDetails } from './../../shared/models/quesDetails.model';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { BUSINESS_REG_APP_CONSTANT } from 'app/config/business-reg-app.constant';
import { BussinessRegAppService } from 'app/service/business-reg-app/bussiness-reg-app.service';
import { Answer } from 'app/shared/models/Answer.model';
import { MeasureStruct } from 'app/shared/models/measureStruct.model';
import { TRCFundClasses } from 'app/shared/models/tRCFundClasses.model';
import { TRCNextSteps } from 'app/shared/models/tRCNextSteps.model';
import { clearError, formSubmit, processNavClk, processTextField } from 'app/shared/Validator/TRCBusQues.validator';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CustomAlertModalComponent } from 'app/shared/shared-component/custom-alert-modal/custom-alert-modal.component';
import { LoaderService } from 'app/service/loader/loader.service';

@Component({
  selector: 'jhi-eappreg-business-questions',
  templateUrl: './eappreg-business-questions.component.html',
  styleUrls: ['./eappreg-business-questions.component.scss']
})
export class EappregBusinessQuestionsComponent implements OnInit {



  measure = 0;
  temp: any;
  eappregBusinessQuestions = this.formBuilder.group({})
  TRCQForms: Answer[] = JSON.parse(sessionStorage.getItem("TRCQForms") ?? "")
  // TRCQForms: Answer[] = []
  answers: Answer[] = [];
  qDetails: QuesDetails[] = [];
  measureStruct: MeasureStruct[] = [];
  tRCFundClasses: TRCFundClasses[] = []
  trcNextSteps: TRCNextSteps = JSON.parse(sessionStorage.getItem("TRCNextSteps") ?? "{}");
  DispSeqInd = "N";
  DispOnlyInd = "N";
  num = 0;
  clkbtn = false;
  hasNextPage = false
  hasPrevPage = false
  qQuestions: any = []
  currrLvl = "1";
  tRCDataErrors: any = [];
  eAppRegConstant = BUSINESS_REG_APP_CONSTANT;
  NgbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false
  };
  errEist = false;
  formObjArray: any[] = []
  loaderService :any



  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private businessRegAppService: BussinessRegAppService,
    private modalService: NgbModal,
    private loader: LoaderService) {
    this.loaderService = this.loader
    sessionStorage.setItem("TRCCurrGrpMetaName", "DUPENTRYGRP")
    sessionStorage.setItem("TRCCurrLevel", "2");
    this.tRCDataErrors = sessionStorage.getItem("TRCDataErrors");

  }


  ngOnInit(): void {
 
  if(sessionStorage.getItem("TRCCurrentPage") === "eappreg_questionnaire"){
    sessionStorage.setItem("TRCCurrentPage","eappreg_business_questions") ;
  }else if(sessionStorage.getItem("TRCCurrentPage") === "eappreg_business_questions"){
    // refreshed
  }else{
    //Didn't come from right program so call error routine.
    this.router.navigate(['error-page'])
  }
    this.returnToPrevOrNxtPage();
  }

  eappreg_business_questions_action(): void {

    this.eappregBusinessQuestions.markAllAsTouched();
    if (formSubmit(this.eappregBusinessQuestions, this.modalService)) {
      this.initialVariables();
      Object.keys(this.eappregBusinessQuestions.value).forEach((ele: string) => {
        const questionnaireObj = this.qQuestions.find((obj: any) => obj.metaName === ele)
        const answerObj = new Answer();
        answerObj.answerTxt = this.eappregBusinessQuestions.get(ele)?.value
        answerObj.questionId = questionnaireObj === undefined ? 0 : questionnaireObj.questionId;
        answerObj.metaName = ele
        const trcqFormIndex = this.TRCQForms.findIndex(trcqObj => trcqObj.metaName === ele)
        if (trcqFormIndex !== -1) {
          this.TRCQForms[trcqFormIndex] = answerObj
        } else {
          this.TRCQForms.push(answerObj)
        }
      })
      sessionStorage.setItem("TRCQForms", JSON.stringify(this.TRCQForms))
      this.getQuesDetails();
    }
    sessionStorage.setItem("TRCQForms", JSON.stringify(this.TRCQForms))
    this.clkbtn = false
  }

  //DECLARE AND INITIALIZE VARIABLES
  initialVariables(): void {

    this.trcNextSteps.exemptFormReq = false;
    this.trcNextSteps.internetFormReq = false;
    this.trcNextSteps.multimediaFormReq = false;
    sessionStorage.setItem("TRCNextSteps", JSON.stringify(this.trcNextSteps))
    this.temp = sessionStorage.setItem("TRCDataErrors", "");
    //sessionStorage.removeItem("TRCDataErrors") ;

    //always create a new list at this point
    if (sessionStorage.getItem("TRCFundClasses")) {

      sessionStorage.removeItem("TRCFundClasses")
      const tRCFundClasses = new TRCFundClasses()
      sessionStorage.setItem("TRCFundClasses", JSON.stringify(tRCFundClasses))

    }

  }

  getQuesDetails(): void {
    this.businessRegAppService.getQuestionDetails(sessionStorage.getItem("TRCBusGrpId") ?? "").subscribe((res: any) => {
      this.qDetails = res;
    }, () => {/*empty*/ },
      () => {
        this.setUpBusinessFundClass();
      })
  }


  //DETERMINE WHICH BUSINESS FUND/CLASSES WILL NEED TO BE SETUP
  setUpBusinessFundClass(): void {
    let measure = 0
    for (let i = 0; i < this.qDetails.length; i++) {
      const resultArray = this.TRCQForms.find(
        obj => obj.questionId === this.qDetails[i].questionId)
      //not all questions are tied to a fund/class
      //if measures are not collected for this question, just add to our f/c structure
      if (resultArray !== undefined && resultArray.answerTxt === "Y") {

        if (this.qDetails[i].revenueType) {
          if (this.qDetails[i].measureId === 0) {
            const measureSt = new MeasureStruct();
            measureSt.measure = 0;
            this.measureStruct.push(measureSt);
            const fundclIndex =this.tRCFundClasses.findIndex(
              obj => obj.revenue_type === this.qDetails[i].revenueType
              )
            if(fundclIndex >= 0){
              this.tRCFundClasses[fundclIndex].measure = measureSt.measure; 
            }else{
              const trcFundClasses = new TRCFundClasses();
              trcFundClasses.revenue_type = this.qDetails[i].revenueType;
              trcFundClasses.measure = measureSt.measure;
              trcFundClasses.description = this.qDetails[i].description;
              this.tRCFundClasses.push(trcFundClasses);
            }

          } else {
            const resultArray1 = this.TRCQForms.find(
              obj => obj.questionId === this.qDetails[i].measureId
            )
            if (resultArray1 !== undefined) {
              measure = Number(resultArray1.answerTxt);
              if (!this.isNumber(measure)) {
                const title = "Confirmation"
                const body = "Please correct the " + measure + " answer.  It must be numeric only."
                const modalRef = this.modalService.open(CustomAlertModalComponent, this.NgbModalOptions)
                modalRef.componentInstance.cModalTitle = title
                modalRef.componentInstance.cModalBody = body

                measure = 0;
                this.errEist = true
                break;
                return;
              }
              
              const fundclIndex =this.tRCFundClasses.findIndex(obj => obj.revenue_type === this.qDetails[i].revenueType)
              if (fundclIndex>=0) {
                this.tRCFundClasses[fundclIndex].measure = this.tRCFundClasses[fundclIndex].measure+measure
              } else {
                const measureSt = new MeasureStruct();
                measureSt.measure = measure;
                this.measureStruct.push(measureSt);
                const trcFundClasses = new TRCFundClasses();
                trcFundClasses.revenue_type = this.qDetails[i].revenueType;
                trcFundClasses.measure = measureSt.measure;
                trcFundClasses.description = this.qDetails[i].description;
                this.tRCFundClasses.push(trcFundClasses);
              }
            }

          }
        }
        this.trcNextSteps.exemptFormReq = this.trcNextSteps.exemptFormReq || this.qDetails[i].specialForm === "EXEMPT"
        this.trcNextSteps.internetFormReq = this.trcNextSteps.internetFormReq || !!(this.qDetails[i].specialForm === "INTERNET")
        this.trcNextSteps.multimediaFormReq = this.trcNextSteps.multimediaFormReq || !!(this.qDetails[i].specialForm === "MULTIMEDIA")
      }

    }
    sessionStorage.setItem("TRCFundClasses", JSON.stringify(this.tRCFundClasses))
    sessionStorage.setItem("TRCNextSteps", JSON.stringify(this.trcNextSteps))
    if (this.errEist === false) {
      this.jumpToNxtPage();
    }
  }

  jumpToNxtPage(): void {
    const tRCFundClasses: TRCFundClasses[] = JSON.parse(sessionStorage.getItem("TRCFundClasses") ?? "");
    const tRCFundClses = this.tRCFundClasses.find(obj => obj.revenue_type === "L050")
    if (tRCFundClasses.length === 0) {

      const title = "Confirmation"
      const body = "Based on the questionnaire answers, we were unable to classify your business.You can double-check your answers.  Did you mean to answer 'no' to all of the additional business activity questions?"
      const modalRef = this.modalService.open(CustomAlertModalComponent, this.NgbModalOptions)
      modalRef.componentInstance.cModalTitle = title
      modalRef.componentInstance.cModalBody = body
      modalRef.result.then((userResponse) => {
        if (userResponse === "OK") {
          this.router.navigate(['/eappreg_questionnaire']);
        }
      });
    } else if (tRCFundClses !== undefined) {
      const title = "Confirmation"
      const body = "The use of online, E-Registration, to register for a Business Tax certificate for a Medical Marijuana Dispensary business is not being accepted at this time.  In addition, mail-in Business Tax Registration application cannot be accepted.  If you operate or plan on operating a Medical Marijuana Dispensary business, you will be required to visit the Office of Finance main public counter office at City Hall, 200 North Spring Street, Room 101, Los Angeles CA 90012 in order to request a Business Tax register for your company.  Thank you."
      const modalRef = this.modalService.open(CustomAlertModalComponent, this.NgbModalOptions)
      modalRef.componentInstance.cModalTitle = title
      modalRef.componentInstance.cModalBody = body
      modalRef.result.then((userResponse) => {
        if (userResponse === "OK") {
          window.location.href = this.eAppRegConstant.OOFHomePage;
        }
      });

    } else {
      sessionStorage.removeItem("TRCDataErrors");
      sessionStorage.setItem("permitQuestions", "[]")
      this.router.navigate(['/eappreg_permit_main']);
    }

  }

  isNumber(n: any): boolean {
    return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
  }

  get sessionStorage(): any {
    return sessionStorage
  }

  ClkNavigattion(event: any): void {
    const input = event.target;
    const result = processNavClk(input.id, this.eappregBusinessQuestions, this.modalService);
    if (result) {
      window.scroll(0,0);
      this.clkNav(this.eappregBusinessQuestions, this.answers, input);
    }
  }

  clkNav(eappregBusinessQuestions: any, answers: Answer[], event: any): void {
    this.formObjArray = []
    Object.keys(eappregBusinessQuestions.value).forEach((ele: string) => {
      const questionnaireObj = this.qQuestions.find((obj: any) => obj.metaName === ele)
      const answerObj = new Answer();
      answerObj.answerTxt = this.eappregBusinessQuestions.get(ele)?.value
      answerObj.questionId = questionnaireObj === undefined ? 0 : questionnaireObj.questionId;
      answerObj.metaName = ele
      this.formObjArray.push(answerObj)
      // const trcqFormIndex = this.TRCQForms.findIndex(trcqObj => trcqObj.metaName === ele)
      // if (trcqFormIndex === -1) {
      //   this.TRCQForms.push(answerObj)
      // }
    })
    this.businessRegAppService.updateTrcSessionForm({
      "trcFormData": this.formObjArray,
      "trcSessionData": this.TRCQForms,
      "qGrpID": sessionStorage.getItem("TRCBusGrpId")
    }).subscribe((res: any) => {
      this.TRCQForms = res
      sessionStorage.setItem("TRCQForms", JSON.stringify(res))
      if (event.id === "nextPageNav") {
        this.num = Number(sessionStorage.getItem("TRCCurrLevel"));
        this.num++;
        this.clkbtn = true;
        sessionStorage.setItem("TRCCurrLevel", String(this.num));
      } else if (event.id === "prevPageNav") {
        this.num = Number(sessionStorage.getItem("TRCCurrLevel"));
        this.num--;
        sessionStorage.setItem("TRCCurrLevel", String(this.num));

      }
      this.returnToPrevOrNxtPage();
    })

  }

  //RETURN PREVIOUS PAGE/NEXT PAGE AVAILABILITY TO BROWSER
  returnToPrevOrNxtPage(): void {

    this.qQuestions = []

    if (Number(sessionStorage.getItem("TRCCurrLevel") ?? "0") < Number(sessionStorage.getItem("TRCMaxLevel") ?? "0")) {
      this.hasNextPage = true
    } else {
      this.hasNextPage = false
    }

    //  To access the level 1 questions from level 2, user has to click the Back
    // button to go back to the Questionnaire page.  User can not access level 1 from
    // within the Additional Business Activity Questions page.  If user is requesting
    // to view level 2 questions, don't show him the previous page button.

    if (Number(sessionStorage.getItem("TRCCurrLevel") ?? "0") > 2) {
      this.hasPrevPage = true
    } else {
      this.hasPrevPage = false
    }

    // GET THE CURRENT LEVEL QUESTIONS TO DISPLAY

    if (Number(sessionStorage.getItem("TRCCurrLevel")) === 1) {
      this.businessRegAppService.getTRCCurrLevel(sessionStorage.getItem("TRCBusGrpId") ?? "", this.currrLvl).subscribe((res: any) => {
        this.qQuestions = res;
      })
    } else {
      this.businessRegAppService.getCurrLvlQuesToDisplay(
        {
          "trcList": this.TRCQForms,
          "bussinessGrpId": sessionStorage.getItem("TRCBusGrpId") ?? "",
          "currLevel": sessionStorage.getItem("TRCCurrLevel") ?? "0"
        }
      ).subscribe((res: any) => {
        this.eappregBusinessQuestions = this.formBuilder.group({})
        this.qQuestions = res;
        if (this.qQuestions.length > 0 && Number(sessionStorage.getItem("TRCCurrLevel")) === 2) {
          const nextPageNav = <HTMLElement>document.getElementById("nextPageNav");
          nextPageNav.style.display = "inline";
          const prevPgObj = <HTMLElement>document.getElementById("prevPageNav");
          prevPgObj.style.display = "none";
          const bSubmit = <HTMLElement>document.getElementById("bSubmit");
          bSubmit.style.display = "none";
        }
        if (this.qQuestions.length > 0 && Number(sessionStorage.getItem("TRCCurrLevel")) === 3) {
          const prevPgObj = <HTMLElement>document.getElementById("prevPageNav");
          prevPgObj.style.display = "inline";
          const bSubmit = <HTMLElement>document.getElementById("bSubmit");
          bSubmit.style.display = "inline";
          const nextPageNav = <HTMLElement>document.getElementById("nextPageNav");
          nextPageNav.style.display = "none";

        } else if (this.qQuestions.length === 0 && Number(sessionStorage.getItem("TRCCurrLevel")) === 3) {
          this.initialVariables();
          this.getQuesDetails();
        }
      })

    }

  }

  update(answers: Answer[]): void {
    for(let i=0;i<answers.length;i++){
      if(!this.TRCQForms.find(ansObj => ansObj.questionId === answers[i].questionId)){
          this.TRCQForms.push(answers[i])
      }
  }
    sessionStorage.setItem("TRCQForms", JSON.stringify(this.TRCQForms))
    this.data()
  }


  data(): void {

    const inputElem: any = document.getElementById("level_table")?.getElementsByTagName("input");

    for (let i = 0; i < inputElem?.length; i++) {
      if (inputElem[i].type === 'radio') {
        (<HTMLElement>inputElem[i]).addEventListener('click', () => {
          clearError(inputElem[i]);
        });
      }
      if (inputElem[i].type === 'text') {
        (<HTMLElement>inputElem[i]).addEventListener('change', () => {
          processTextField(inputElem[i], this.modalService);
        })
      }
    }
  }

}
